var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.611328,
    width: 47.3806,
    height: 48,
    rx: 8,
    fill: "#2758A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4176 13.9167C14.3272 13.9167 13.4434 14.7375 13.4434 15.75V32.25C13.4434 33.2625 14.3272 34.0833 15.4176 34.0833H33.1853C34.2756 34.0833 35.1595 33.2625 35.1595 32.25V15.75C35.1595 14.7375 34.2756 13.9167 33.1853 13.9167H15.4176ZM24.6355 20.7504C24.4534 20.4903 24.142 20.3333 23.8079 20.3333C23.4737 20.3333 23.1623 20.4903 22.9803 20.7504L16.5641 29.9171C16.3668 30.199 16.3515 30.5585 16.5242 30.8539C16.6968 31.1494 17.0298 31.3333 17.3917 31.3333H30.224C30.586 31.3333 30.9189 31.1494 31.0916 30.8539C31.2642 30.5585 31.2489 30.199 31.0516 29.9171L24.6355 20.7504ZM27.2627 19.875C27.2627 18.6093 28.3676 17.5833 29.7305 17.5833C31.0933 17.5833 32.1982 18.6093 32.1982 19.875C32.1982 21.1406 31.0933 22.1667 29.7305 22.1667C28.3676 22.1667 27.2627 21.1406 27.2627 19.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryTag);
export default __webpack_public_path__ + "static/media/galleryTag.9ca02fb3fdcd0ad84b2c7df02b506700.svg";
export { ForwardRef as ReactComponent };